import { query } from '@ember-data/json-api/request';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type SessionService from 'bcl/services/session';

export default class AuthAdminRoute extends Route {
  @service store;
  @service declare session: SessionService;
  @service declare router: RouterService;
  beforeModel() {
    if (!this.session.isAdmin) {
      this.router.transitionTo('auth');
    }
  }
  async model() {
    await this.store.request(query('order'));
    return {
      users: (await this.store.request({ url: '/api/users' })).content.data,
      version: await (await fetch('/api/admin/version')).text(),
    };
  }
}
